import { ConfigurationField } from '@/models/configuration/Field';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { DataSet } from '../models/dataset/DataSet';
import { DataSetField } from '../models/dataset/DataSetField';
import { TableDataSetField } from '../models/tableDataset/TableDataSetField';

class UtilsHelperClass {
    public generateUserConfigurationField(identifier: string, name: string): ConfigurationField {
        const userCF = new ConfigurationField();

        userCF.identifier = identifier;
        userCF.name = name;
        userCF.type = FieldTypeEnum.TEXT;

        return userCF;
    }

    public generateUserDataSet(identifier: string, value?: string): DataSetField {
        const userDSF = new DataSetField();

        userDSF.identifier = identifier;
        userDSF.valueString = value;

        return userDSF;
    }

    public generateUserTableDataSetField(identifier: string, name: string, type: FieldTypeEnum): TableDataSetField {
        const userTDSF = new TableDataSetField();

        userTDSF.identifier = identifier;
        userTDSF.name = name;
        userTDSF.type = type;

        return userTDSF;
    }
}

export default UtilsHelperClass;
